<template>
  <cadastro-base
    :salvar="abrirModal"
    :cancelar-cadastro="fechar"
  >
    <template slot="conteudo">
      <b-row>
        <b-col
          cols="12"
        >
          <upload-certificado
            ref="uploadCertificado"
            :disabled="disabled"
            :disabled-inputs="disabledInputs"
            :disabled-user-data="disabledGeral"
            :id-upload="'certificado'"
            :text="certificado.nome"
            :value="certificado"
            :arquivo="certificado.certificadoArquivo"
            @selecionado="selecionadoCertificado"
            @removido="arquivoCertificadoRemovido"
            @empresa-certificados="empresasCertificado"
            @data-certificados="setFormData"
          />
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Observação"
            class="col-12 p-0"
          >
            <b-textarea
              v-model="certificado.observacao"
              style="border-radius: 8px;"
              :disabled="disabledObservacao"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <empresas-vinculadas
            ref="empresas-vinculadas"
            v-model="certificado"
            :disabled="disabledGeral"
            :visualizacao-opcoes="visualizacao"
            :cadastro-usuario="false"
            :filtros-vinculadas="filtrosVinculadas"
            :filtros-nao-vinculadas="filtrosNaoVinculadas"
            :filtros-rapidos="filtrosRapidos"
            :filtros-rapidos-vinculados="filtrosRapidosVinculados"
            :tem-filtro-rapido="true"
            :vinculadas="certificado.vinculadas"
          />
        </b-col>
      </b-row>
      <modal-dispensar-certificados
        ref="modalDispensarCertificados"
        :certificados="certificadosResumidos"
        :mensagem="mensagem"
        @salvar-certificado="salvar"
      />
    </template>
  </cadastro-base>
</template>
<style lang="scss" scoped>

</style>
<script>
import apiCertificado from '@/app-modulo/comuns/certificado/shared/services/api'
import { getUserData, permitidoAcessarRecursoSeNaoAdmin } from '@/auth/utils'

export default {
  name: 'CadastroCertificado',
  components: {
    CadastroBase: () => import('@/shared/components/cadastro-base/CadastroBase.vue'),
    uploadCertificado: () => import('@/app-modulo/comuns/certificado/shared/components/dados-certificado/UploadCertificado.vue'),
    EmpresasVinculadas: () => import('@/app-modulo/comuns/certificado/shared/components/vinculo-empresas/VinculoEmpresas.vue'),
    ModalDispensarCertificados: () => import('@/app-modulo/comuns/certificado/shared/components/certificado-dispensar/ModalCertificadoDispensar.vue'),
  },
  props: {

  },
  data() {
    return {
      disabled: false,
      disabledInputs: false,
      disabledObservacao: false,
      disabledGeral: false,
      tipo: ['A1', 'A3'],
      modelo: ['E-CNPJ', 'E-CPF'],
      certificado: {
        id: 0,
        vinculadas: [],
        naoVinculadas: [],
        totalVinculadas: 0,
        totalNaoVinculadas: 0,
        emProcesso: false,
        naoEnviarAlerta: false,
        certificadoArquivo: null,
        certificadoIdsParaDispensar: [],
      },
      formDataCertificado: null,
      visualizacao: {
        evento(id, filtro) {
          return apiCertificado.getEmpresasPorCertificado(id, filtro)
        },
      },
      filtrosVinculadas: [{ colunas: ['CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosNaoVinculadas: [{ colunas: ['CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosRapidos: [
        {
          id: 'Ativo',
          colunas: ['Ativo'],
          label: 'Ativos',
          valor: 'false',
        },
        {
          id: 'Inativo',
          colunas: ['Ativo'],
          label: 'Inativos',
          valor: 'true',
        },
        {
          id: 'SemCertificado',
          colunas: ['SemCertificado'],
          label: 'Sem certificado / procuração',
          valor: this.$route.params.id,
        },
        {
          id: 'ComCertificado',
          colunas: ['ComCertificado'],
          label: 'Com certificado',
          valor: this.$route.params.id,
        },
      ],
      filtrosRapidosVinculados: [
        {
          id: 'Ativo',
          colunas: ['Ativo'],
          label: 'Ativos',
          valor: 'false',
        },
        {
          id: 'Inativo',
          colunas: ['Ativo'],
          label: 'Inativos',
          valor: 'true',
        },
      ],
      loadingCertificado: false,
      certificadosResumidos: [],
      mensagem: 'Carregando...',
    }
  },
  created() {
    this.getEmpresas()
    this.disabledCampos()
  },
  methods: {
    abrirModal() {
      if (this.$route.path.indexOf('editar') > 0 || !this.certificado.vinculadas || this.certificado.vinculadas.length === 0) {
        this.salvar()
      } else {
        const formDta = this.getFormData(this.formDataCertificado)
        apiCertificado.getCertficadosDispensar(formDta)
          .then(payload => {
            this.certificadosResumidos = payload.data
            if (payload.data.length > 0) {
              this.$refs.modalDispensarCertificados.$refs.modalDispensarCertificados.show()
            } else {
              this.salvar()
            }
          })
          .catch(err => {
            this.$refs.modalDispensarCertificados.$refs.modalDispensarCertificados.fechadoModal()
            this.$erro(err)
          })
      }
    },
    salvar(certificadoIds) {
      if (certificadoIds !== undefined && certificadoIds !== null) {
        this.$set(this.certificado, 'certificadoIdsParaDispensar', certificadoIds)
      }
      if (!this.certificado.vinculadas || this.certificado.vinculadas.length === 0) {
        if (this.certificado.modelo === 1) {
          this.$erro('Não existe empresa vinculada ao certificado, essa informação é obrigatória!')
        }
        if (this.certificado.modelo === 2) {
          this.$erro('Não existe sócio vinculado ao certificado, essa informação é obrigatória!')
        }
      } else {
        const formDta = this.getFormData(this.formDataCertificado)
        this.salvarOuEditar(formDta)
      }
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'certificados' })
      } else {
        this.$router.go(-1)
      }
    },
    selecionadoCertificado(nome) {
      this.certificado.certificadoSelecionado = this.$refs.uploadCertificado.value[0] !== undefined
      this.$set(this.certificado, 'nomeArquivoCertificado', nome)
      this.$set(this.certificado, 'senha', null)
      this.$set(this.certificado, 'dataVencimentoCertificado', null)
    },
    arquivoCertificadoRemovido() {
      this.disabledInputs = false
      this.formDataCertificado = null
      this.certificado.certificadoSelecionado = false
      this.$set(this.certificado, 'nomeArquivoCertificado', '')
      this.$set(this.certificado, 'certificadoArquivo', null)
      this.$set(this.certificado, 'senha', null)
      this.$set(this.certificado, 'dataVencimentoCertificado', null)
    },
    getEmpresas() {
      if (this.$route.path.indexOf('editar') > 0) {
        const { id } = this.$route.params

        apiCertificado.GetCertificadoBy(id).then(payload => {
          this.certificado = payload.data
          if (payload.data.tipo === 1) {
            this.disabledInputs = true
          }
        })
          .catch(err => {
            this.$erro(err)
          })
      }
    },
    empresasCertificado(empresas) {
      if (empresas && empresas.length > 0) {
        this.$set(this.certificado, 'vinculadas', empresas)
        this.$set(this.certificado, 'naoVinculadas', [])
      }
    },
    setFormData(data) {
      this.certificado.porProducao = true
      this.formDataCertificado = data
    },
    getFormData(valor) {
      this.certificado.naoVinculadas = []
      this.certificado.certificadoArquivo = []
      const formData = new window.FormData()
      const fileCertificado = valor
      if (valor) {
        formData.append('file', fileCertificado.file, fileCertificado.filename || fileCertificado.name)
      }
      formData.append('body', JSON.stringify(this.certificado))
      return formData
    },
    salvarOuEditar(formDta) {
      const userData = getUserData()
      const permissaoUpdate = permitidoAcessarRecursoSeNaoAdmin('certificado', 'update')
      if (this.$route.path.indexOf('editar') > 0) {
        if (userData.observacaoCertificado && !permissaoUpdate && !userData.admin) {
          const newFormData = new window.FormData()
          newFormData.append('body', JSON.stringify(this.certificado.observacao))
          apiCertificado.updateObservacao(this.certificado.id, newFormData).then(() => {
            this.fechar()
            this.$sucesso('Certificado atualizado com sucesso!')
          }).catch(() => {
            this.$erro('Ocorreu um erro ao atualizar')
          })
        } else {
          apiCertificado.update(this.certificado.id, formDta).then(() => {
            this.fechar()
            this.$sucesso('Certificado atualizado com sucesso!')
          }).catch(() => {
            this.$erro('Ocorreu um erro ao atualizar')
          })
        }
      } else {
        apiCertificado.createCertficado(formDta).then(() => {
          this.fechar()
          this.$sucesso('Certificado salvo com sucesso!')
        }).catch(() => {
          this.$erro('Ocorreu um erro ao salvar')
        })
      }
    },
    disabledCampos() {
      const userData = getUserData()
      const permissaoUpdate = permitidoAcessarRecursoSeNaoAdmin('certificado', 'update')
      if (userData.observacaoCertificado && !userData.admin && !permissaoUpdate) {
        this.disabledObservacao = false
        this.disabledGeral = true
      }
      if (userData.observacaoCertificado && (userData.admin || permissaoUpdate)) {
        this.disabledObservacao = false
        this.disabledGeral = false
      }
      if (!userData.observacaoCertificado) {
        this.disabledObservacao = true
        this.disabledGeral = false
      }
    },
  },
}
</script>
